import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CommonService } from '@sharedModule/services/common/common.service';
import { switchMap, map, catchError, of } from 'rxjs';
import {
  loadSourceCountry,
  loadSourceCountrySuccess,
  loadSourceCountryFailure,
} from './source-country.actions';

@Injectable()
export class SourceCountryEffect {
  loadSourceCountry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSourceCountry),
      switchMap(({ payload }) =>
        this.commonService.getSourceCountryList(payload).pipe(
          map(data => {
            if (data.response) {
              return loadSourceCountrySuccess({
                sourceCountries: data.response.source_currency,
              });
            } else {
              return loadSourceCountryFailure({
                error: 'no data found',
              });
            }
          }),
          catchError(error =>
            of(loadSourceCountryFailure({ error: error.error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private commonService: CommonService
  ) {}
}
